import { useTranslation } from 'react-i18next'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import ContactHero from './hero'
import ContactForm from './form'
import ContactInfo from './info'
import Seo from '@/components/seo/seo'
import { breadcrumbSchema } from '@/components/seo/json-ld'
import { resolveLang } from '@/lib/site'

export default function Contact() {
  const { t, i18n } = useTranslation()
  const lang = resolveLang(i18n.resolvedLanguage)

  return (
    <>
      <Seo
        title={t('seo.contact.title') as string}
        description={t('seo.contact.description') as string}
        path="/contact"
        jsonLd={breadcrumbSchema(lang, [
          { name: 'Bravic', path: '/' },
          { name: t('seo.contact.title') as string, path: '/contact' },
        ])}
      />
      <Header />
      <main className="relative pt-20 md:pt-28 lg:pt-32 pb-12 md:pb-24 overflow-hidden bg-[radial-gradient(circle_at_20%_30%,rgba(0,166,147,0.05)_0%,transparent_50%),radial-gradient(circle_at_80%_70%,rgba(91,218,198,0.03)_0%,transparent_50%)]">
        <ContactHero />
        <ContactForm />
        <ContactInfo />
      </main>
      <Footer />
    </>
  )
}
